// extracted by mini-css-extract-plugin
export var summaryTitle = "summary-module--summaryTitle--Tun6Y";
export var blog = "summary-module--blog--7g4I0";
export var blogPostLink = "summary-module--blogPostLink---Y1mZ";
export var summaryContainer = "summary-module--summaryContainer--dcHSR";
export var datePosted = "summary-module--datePosted--Bxij-";
export var summaryArticle = "summary-module--summaryArticle--tTdko";